import { createStore } from 'vuex'

export default createStore({
  state: {
    userInfo: {},
    menus: [],
    lang: window.localStorage.getItem("lang") || 'zh-CN',
  },
  mutations: {
    setUserInfo (state, data) {
      state.userInfo = data
    },
    setUserMenus (state, data) {
      state.menus = data
    },
    setLocale(state, data) {
      state.lang = data || 'zh-CN'
      window.localStorage.setItem("lang", data || '')
    }
  },
  actions: {
  },
  modules: {
  }
})